module.exports = __webpack_public_path__ + "static/img/23.edb1f0ea.jpg";